import { InterwillDto } from '@/entities/interwills';

import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const migrateInterwillVerifications = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...(data as InterwillDto) };
  const testatorVerification = newData.executionState?.testatorVerification;
  const witnessVerification = newData.executionState?.witnessVerifications;
  const videoCertificates = newData.executionState?.videoCertificates;

  // move generatedPdfPath from videoCertificates to testatorVerification and witnessVerifications
  if (videoCertificates) {
    Object.keys(videoCertificates).forEach((attachmentId) => {
      if ('generatedPdfPath' in videoCertificates[attachmentId]) {
        if (testatorVerification && testatorVerification.id === attachmentId) {
          testatorVerification.generatedPdfPath = videoCertificates[attachmentId]
            .generatedPdfPath as string;
          delete videoCertificates[attachmentId].generatedPdfPath;
        } else if (witnessVerification) {
          Object.keys(witnessVerification).forEach((witnessId) => {
            if (
              witnessVerification[witnessId].id === attachmentId &&
              'generatedPdfPath' in videoCertificates[attachmentId]
            ) {
              witnessVerification[witnessId].generatedPdfPath = videoCertificates[attachmentId]
                .generatedPdfPath as string;
              delete videoCertificates[attachmentId].generatedPdfPath;
            }
          });
        }
      }
    });
  }

  // fix recordtingDate typo in testatorVerification and witnessVerifications
  //  and delete metadata field
  if (
    testatorVerification &&
    'recordtingDate' in testatorVerification &&
    testatorVerification?.recordtingDate
  ) {
    newData.executionState!.testatorVerification!.recordingDate =
      testatorVerification.recordtingDate as string;
    delete testatorVerification.recordtingDate;
  }
  if (testatorVerification && 'metadata' in testatorVerification) {
    delete testatorVerification.metadata;
  }

  if (witnessVerification) {
    Object.keys(witnessVerification).forEach((key) => {
      if (witnessVerification[key] && 'recordtingDate' in witnessVerification[key]) {
        newData.executionState!.witnessVerifications[key].recordingDate = witnessVerification[key]
          .recordtingDate as string;
        delete witnessVerification[key].recordtingDate;
      }
      if ('metadata' in witnessVerification[key]) {
        delete witnessVerification[key].metadata;
      }
    });
  }

  // check if certificates exists and remove the record if it has no pdf generated
  if (testatorVerification && !testatorVerification.generatedPdfPath) {
    newData.executionState!.testatorVerification = null;
  }

  if (witnessVerification) {
    Object.keys(witnessVerification).forEach((key) => {
      if (witnessVerification[key] && !witnessVerification[key].generatedPdfPath) {
        delete newData.executionState!.witnessVerifications[key];
      }
    });
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.INTERWILLS, migrateItemFunction: migrateInterwillVerifications },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration14: MigrationType = {
  migrate,
  version: 15,
};
